module.exports = __webpack_public_path__ + "img/7.e44461c8.jpg";